import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notificacao-dialog',
  templateUrl: './notificacao-dialog.component.html',
  styleUrls: ['./notificacao-dialog.component.scss']
})
export class NotificacaoDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/notificacao/notificacao-dialog/notificacao-dialog.component.ts